/**
 * ProposalStatusBadge — Reusable status badge for proposals.
 *
 * Uses PROPOSAL_STATUSES config from mockDealData for consistent colors.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PROPOSAL_STATUSES } from '@/components/deal/mockDealData';

export default function ProposalStatusBadge({ status }) {
  const config = PROPOSAL_STATUSES[status] || PROPOSAL_STATUSES.draft;
  return (
    <Badge className={`${config.className} text-[10px]`}>
      {config.label}
    </Badge>
  );
}
